/**
 * Created by jiachenpan on 16/11/18.
 *
 *  appkey and scret for website
 *   0136652484=6D9D23399E4BF100FB8F93CC9160D511
 */
import { store } from "./store.js";
import Vue from "vue";
import md5 from "js-md5";
let appKey = "0136652484";
let scret = "6D9D23399E4BF100FB8F93CC9160D511";

export function requestHeaderEncryption() {
  //请求头加密

  let timestamp = Date.parse(new Date());

  return { sign: md5(md5(scret) + appKey), timestamp, appKey };
}

//写cookies
export function setCookie(name, value) {

  var hours = 10 
  var date=new Date();
  date.setTime(date.getTime() + hours * 3600 * 1000);
//   date.setTime(date.getTime() +  20 * 1000);
  document.cookie = name + "=" + escape(value) + ";expires=" + date.toGMTString();
}
//读取cookies
export function getCookie(name) {
  var arr,
    reg = new RegExp("(^| )" + name + "=([^;]*)(;|$)");
  if ((arr = document.cookie.match(reg))) return unescape(arr[2]);
  else return null;
}
//删除cookies
export function delCookie(name) {
  var exp = new Date();
  exp.setTime(exp.getTime() - 1);
  var cval = getCookie(name);
  if (cval != null)
    document.cookie = name + "=" + cval + ";expires=" + exp.toGMTString();
}

// 判断变量的类型
export function getType(obj){
	var str = Object.prototype.toString.call(obj);
	var map={
		'[object Boolean]'  : 'boolean', 
		'[object Number]'   : 'number', 
		'[object String]'   : 'string', 
		'[object Function]' : 'function', 
		'[object Array]'    : 'array', 
		'[object Date]'     : 'date', 
		'[object RegExp]'   : 'regExp', 
		'[object Undefined]': 'undefined',
		'[object Null]'     : 'null', 
		'[object Object]'   : 'object'
	}
	if(obj instanceof Element){ //判断是否是dom元素，如div等
		return "element";
	}
	return map[str];
}


//深拷贝函数
export function deepCopy(p){
  console.log("qq"+p)
	var obj;
	var str = getType(p);
	if(str == 'array'){
		obj = [];
		for (var i = 0; i < p.length; i++) {
			obj.push(arguments.callee(p[i]));  //回调自己
		}
	}else if(str == 'object'){
		obj = {};
		for(var i in p){
			obj[i] = arguments.callee(p[i]);
		}
  }
  // else{
	// 	return p;
	// }
	return obj;
}



// WEBPACK FOOTER //
// ./src/utils/index.js